module.exports = __webpack_public_path__ + "img/onepack-inactive.77aa195a.svg";